function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import * as DOMPurify from "dompurify";
import * as React from "react";
import { TOP_NAV_HEIGHT } from "../NavigationUtils/NavigationUtils";
import { throttle } from "../throttle/throttle";
/**
 * These tags are always forbidden in setInnerHtmlSanitized.
 * See http://go/dompurify-security
 * The default allowed tags are the set of tags defined at
 * https://github.com/cure53/DOMPurify/blob/main/src/tags.js
 * excluding FORBIDDEN_TAGS.
 */ var FORBIDDEN_TAGS = [
    "style"
];
var KAGGLE_DOMAIN_RE = /^(www\.|staging\.|admin\.)?kaggle\.com$/i;
var EXTERNAL_DOMAIN_REL_VALUES = [
    "noreferrer",
    "nofollow", 
];
var ALLOWED_IMG_PREFIXES = [
    "i.postimg.cc/",
    "i.imgur.com/",
    "pbs.twimg.com/",
    "i.ibb.co/",
    "raw.githubusercontent.com/",
    "user-images.githubusercontent.com/",
    "storage.googleapis.com/",
    "www.kaggleusercontent.com/",
    "www.googleapis.com/download/storage/v1", 
];
var DEFAULT_SANITIZE_CONFIG = {
    allowUnsanitized: false,
    allowExternalImages: true,
    allowAnchorTarget: false
};
// Returns "noreferrer nofollow" if the href is an external domain.
export var getRelAttrForHref = function(href) {
    if (isKaggleUrl(href)) {
        return undefined;
    }
    return EXTERNAL_DOMAIN_REL_VALUES.join(" ");
};
/**
 * Takes a function that matches URL objects and returns a
 * function that matches arbitrary stings - which may or may not
 * be valid URLs. Invalid URLs will return false.
 */ var getUrlStringMatcher = function(urlFn) {
    return function(urlStr) {
        var url;
        try {
            url = new URL(urlStr, window.location.href);
        } catch (_) {
            // Return false for unparseable URL.
            return false;
        }
        return urlFn(url);
    };
};
var isKaggleDomain = function(url) {
    return url.hostname.match(KAGGLE_DOMAIN_RE) !== null;
};
/**
 * Returns true if the URL is relative or a Kaggle domain.
 */ export var isKaggleUrl = getUrlStringMatcher(isKaggleDomain);
/**
 * Returns true if the URL is relative, a Kaggle domain,
 * or one of the allowed 3rd party image domains.
 */ export var isAllowedImgDomainUrl = getUrlStringMatcher(function(url) {
    if (isKaggleDomain(url)) {
        return true;
    }
    var hostAndPath = url.hostname.toLowerCase() + url.pathname.toLocaleLowerCase();
    // Do a head match on domain and path.
    return ALLOWED_IMG_PREFIXES.some(function(prefix) {
        return hostAndPath.indexOf(prefix) === 0;
    });
});
/**
 * Adds the attribute rel="noreferrer nofollow" if the anchor
 * element links to a non-Kaggle domain.
 */ export var processAnchorRel = function(elem) {
    var href = elem.getAttribute("href");
    if (href !== null && !isKaggleUrl(href)) {
        var currentRel = elem.getAttribute("rel") || "";
        // The same node can be processed multiple times, so don't duplicate values.
        var relVals = new Set(_toConsumableArray(currentRel.split(/\s+/)).concat(_toConsumableArray(EXTERNAL_DOMAIN_REL_VALUES)));
        elem.setAttribute("rel", _toConsumableArray(relVals).join(" "));
    }
};
var cachedImageIcon = null;
var getImageIcon = function() {
    if (cachedImageIcon !== null) {
        return cachedImageIcon;
    }
    var icon = document.createElement("i");
    icon.setAttribute("class", "rmwc-icon google-material-icons markdown-renderer-image-icon");
    var iconText = document.createTextNode("image");
    icon.appendChild(iconText);
    cachedImageIcon = icon;
    return icon;
};
/**
 * Replaces 3rd-party image elements with links.
 */ export var processImgSrc = function(elem) {
    var src = elem.getAttribute("src");
    if (src !== null && !isAllowedImgDomainUrl(src)) {
        // Create a new link that links to the image src.
        var link = document.createElement("a");
        link.setAttribute("href", src);
        link.setAttribute("class", "external-img-link");
        // Add an icon.
        link.appendChild(getImageIcon());
        // Set the text of the link.
        var text = document.createTextNode(src);
        link.appendChild(text);
        // Replace the img element.
        elem.replaceWith(link);
    }
};
/**
 * Type-guard that narrows Element to HTMLAnchorElement
 */ var nodeIsAnchor = function(node) {
    return node.nodeType === 1 && node.nodeName === "A";
};
/**
 * Type-guard that narrows Element to HTMLAnchorElement
 */ var nodeIsImg = function(node) {
    return node.nodeType === 1 && node.nodeName === "IMG";
};
/**
 * Processes a single HTLM Element, possibly modifying it.
 * Some of the behavior is dictated by SanitizeConfig.
 */ var processElement = function(currentNode, sanitizeConfig) {
    if (nodeIsAnchor(currentNode)) {
        processAnchorRel(currentNode);
    } else if (nodeIsImg(currentNode) && !sanitizeConfig.allowExternalImages) {
        processImgSrc(currentNode);
    }
    return currentNode;
};
export function setInnerHtmlSanitized(element, html, options) {
    // Merge options with the default config.
    var config = _objectSpread({}, DEFAULT_SANITIZE_CONFIG, options || {});
    var allowUnsanitized = config.allowUnsanitized, allowAnchorTarget = config.allowAnchorTarget;
    if (!allowUnsanitized) {
        var processor = function(elem) {
            return processElement(elem, config);
        };
        /**
     * Adds a hook to the DOMPurify config for pre-processing elements.
     * This allows for manipulating elements via the DOM api before the
     * sanitization step.
     * https://github.com/cure53/DOMPurify#hooks
     */ DOMPurify.addHook("beforeSanitizeElements", processor);
        html = DOMPurify.sanitize(html, {
            FORBID_TAGS: _toConsumableArray(FORBIDDEN_TAGS),
            ADD_ATTR: allowAnchorTarget ? [
                "target"
            ] : undefined
        });
        // Remove the hook when processing is finished.
        DOMPurify.removeHook("beforeSanitizeElements");
    }
    if ("innerHTML" in element) {
        element.innerHTML = html;
        return element;
    } else {
        return(/*#__PURE__*/ React.cloneElement(element, {
            dangerouslySetInnerHTML: {
                __html: html
            }
        }));
    }
}
// Set all external image links to open in a new tab.
export var processExternalImgLinks = function(container) {
    Array.from(container.getElementsByClassName("external-img-link")).forEach(function(link) {
        link.setAttribute("target", "_blank");
    });
};
export function isScreenUnderWidth(widthInPx) {
    // Added fallback to handle errors that occur in unit test context.
    try {
        return window.matchMedia("(max-width: ".concat(widthInPx, "px)")).matches;
    } catch (err) {
        // tslint:disable-next-line: no-console
        console.warn("Error occurred calling window.matchMedia.", _instanceof(err, Error) && err.message);
        return false;
    }
}
export function useMobileWidth(widthInPx) {
    var ref = _slicedToArray(React.useState(isScreenUnderWidth(widthInPx)), 2), isMobileWidth = ref[0], setIsMobileWidth = ref[1];
    React.useEffect(function() {
        var listener = throttle(function() {
            return setIsMobileWidth(isScreenUnderWidth(widthInPx));
        }, 500);
        window.addEventListener("resize", listener);
        return function() {
            return window.removeEventListener("resize", listener);
        };
    });
    return isMobileWidth;
}
/**
 * Returns the BoundingClientRect object of the viewport (what
 * window.getBoundingClientRect() would return if that API existed)
 */ export function getViewportRect() {
    var html = document.documentElement;
    return makeDomRect({
        top: 0,
        bottom: html.clientHeight,
        left: 0,
        right: html.clientWidth
    });
}
/**
 * Returns the intersection rectangle of two DOMRect objects, typically
 * generated with element.getBoundingClientRect()
 */ export function getIntersectionRect(rect1, rect2) {
    return makeDomRect({
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom),
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right)
    });
}
/**
 * Whether the first rectangle is contained entirely within the second
 * rectangle. DOMRect instances are generated using
 * element.getBoundingClientRect()
 */ export function containsRect(rect1, rect2) {
    return rect1.top >= rect2.top && rect1.left >= rect2.left && rect1.right <= rect2.right && rect1.bottom <= rect2.bottom;
}
// The next three functions are all from
// https://stackoverflow.com/questions/123999/how-can-i-tell-if-a-dom-element-is-visible-in-the-current-viewport/
/**
 * Tests whether the element's bounds are at least partially visible within
 * the current viewport
 */ export function isElementPartiallyInViewport(el) {
    var rect = el.getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    var windowWidth = window.innerWidth || document.documentElement.clientWidth;
    var vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
    var horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
    return vertInView && horInView;
}
/**
 * Tests whether the element's bounds are entirely visible within the
 * current viewport
 */ export function isElementCompletelyInViewport(el) {
    var rect = el.getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    var windowWidth = window.innerWidth || document.documentElement.clientWidth;
    return rect.left >= 0 && rect.top >= 0 && rect.left + rect.width <= windowWidth && rect.top + rect.height <= windowHeight;
}
/**
 * Tests whether the element is at least partially inside the viewport and
 * whether any part of it is visible to the user (not overlapped, etc)
 */ export function isElementVisible(el) {
    var rect = el.getBoundingClientRect();
    var vWidth = window.innerWidth || document.documentElement.clientWidth;
    var vHeight = window.innerHeight || document.documentElement.clientHeight;
    var efp = function(x, y) {
        return document.elementFromPoint(x, y);
    };
    // Return false if it's not in the viewport
    if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight) {
        return false;
    }
    // Return true if any of its four corners are visible
    return el.contains(efp(rect.left, rect.top)) || el.contains(efp(rect.right, rect.top)) || el.contains(efp(rect.right, rect.bottom)) || el.contains(efp(rect.left, rect.bottom));
}
/**
 * Makes a DOMRect object from top/bottom/left/right points.
 */ export function makeDomRect(param) {
    var top = param.top, bottom = param.bottom, left = param.left, right = param.right;
    var rect = {
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        x: left,
        y: top,
        height: bottom - top,
        width: right - left
    };
    return _objectSpread({}, rect, {
        toJSON: function() {
            return rect;
        }
    });
}
export var getSiteScrollContainer = function() {
    return document.getElementById("site-content");
};
export function scrollToOffset(topOffset) {
    var container = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getSiteScrollContainer(), options = arguments.length > 2 ? arguments[2] : void 0;
    if (!container) {
        return;
    }
    if (options === null || options === void 0 ? void 0 : options.smooth) {
        try {
            var ref;
            container.scroll({
                top: topOffset - ((ref = options === null || options === void 0 ? void 0 : options.topOffset) !== null && ref !== void 0 ? ref : 0),
                left: container.scrollLeft,
                behavior: "smooth"
            });
            return;
        } finally{}
    }
    container.scrollTop = topOffset;
}
export function scrollToElement(target) {
    var container = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getSiteScrollContainer(), options = arguments.length > 2 ? arguments[2] : void 0;
    if (!container || !target) {
        return;
    }
    var ref;
    var topOffset = (ref = options === null || options === void 0 ? void 0 : options.topOffset) !== null && ref !== void 0 ? ref : container === getSiteScrollContainer() ? TOP_NAV_HEIGHT : 0;
    var scrollTop = target.getBoundingClientRect().top + container.scrollTop - topOffset;
    if (options === null || options === void 0 ? void 0 : options.smooth) {
        try {
            container.scroll({
                top: scrollTop,
                left: container.scrollLeft,
                behavior: "smooth"
            });
            return;
        } finally{}
    }
    container.scrollTop = scrollTop;
}
export var checkVisibilityAndScroll = function(ref, topOffset) {
    if (ref.current !== null) {
        if (!isElementCompletelyInViewport(ref.current)) {
            scrollToElement(ref.current, getSiteScrollContainer(), {
                topOffset: topOffset
            });
        }
    }
};
export function scrollToId(id) {
    var container = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getSiteScrollContainer(), options = arguments.length > 2 ? arguments[2] : void 0;
    scrollToElement(document.getElementById(String(id)), container, options);
}
export function scrollToHash() {
    var container = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getSiteScrollContainer(), options = arguments.length > 1 ? arguments[1] : void 0;
    scrollToId(window.location.hash.slice(1), container, options);
}
export var copyToClipboard = function(text) {
    var copyFunction = function(e) {
        e.clipboardData.setData("text/plain", text);
        e.preventDefault();
        document.removeEventListener("copy", copyFunction);
    };
    document.addEventListener("copy", copyFunction);
    document.execCommand("copy");
};
export function pathnameToPathArray(pathname) {
    return pathname.split("/").filter(function(p) {
        return !!p;
    }).map(function(e) {
        return e.toLowerCase();
    });
}
